module.exports = __webpack_public_path__ + "media/img/livetrend-copy-2@2x-4e830b664138655c14a521964a7e195f.png";